<template>
  <div class="box">
    <div class="seach-wrap">
      <div class="search-item-box">
        <el-input
          placeholder="请输入名称"
          v-model.trim="searchObj.formName"
          class="inp-text"
          size="small"
          clearable
        ></el-input>
      </div>
      <div class="seach-btn">
        <el-button type="primary" @click="getTableData" size="small"
          >查询</el-button
        >
        <el-button type="primary" plain @click="resetSeach" size="small"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table-wrap">
      <div class="btn-wrap">
        <div class="left-wrap"></div>
        <div class="right-wrap">
          <el-button type="primary" @click="handelClickAdd" size="small"
            >添加</el-button
          >
        </div>
      </div>
      <el-table
        :data="postList"
        stripe
        border
        @expand-change="expandChange"
        row-key="formBid"
        :expand-row-keys="expandRowKeys"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.rowDataList"
              stripe
              border
              class="small-table"
              row-key="itemBid"
            >
              <el-table-column
                label="表单选项名称 "
                prop="itemName"
                width="120"
              >
              </el-table-column>
              <el-table-column label="电子表单项">
                <template slot-scope="scope">
                  <!-- {{ scope.row }} -->
                  <el-tag
                    :key="tag.dsBid"
                    v-for="tag in scope.row.dsList"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(scope.row.dsList, tag)"
                  >
                    {{ tag.value }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150px">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    popper-class="popper-class"
                    content="编辑"
                    placement="bottom-end"
                  >
                    <el-button
                      icon="el-icon-edit-outline"
                      circle
                      size="20"
                      type="success"
                      @click="handelRowClickEdit(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    popper-class="popper-class"
                    content="删除"
                    placement="bottom-end"
                  >
                    <el-button
                      icon="el-icon-delete"
                      circle
                      type="success"
                      @click="handleRowDelete(scope.row)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- //---------------- -->
            <div class="pagination-wrap" v-if="totalCount2 > 0">
              <div>
                <span>共</span>
                <span>{{ totalCount2 }}</span>
                <span>条,</span>
                <span
                  >每页显示
                  <el-select
                    v-model="searchRowObj.pageSize"
                    placeholder="请选择"
                    @change="pageSizeChange2"
                    size="small"
                  >
                    <el-option
                      v-for="item in pageNumberList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option> </el-select
                  >条</span
                >
              </div>
              <div
                class="pagination-left"
                v-if="totalCount2 > searchRowObj.pageSize"
              >
                <span
                  >共{{
                    Math.ceil(totalCount2 / searchRowObj.pageSize)
                  }}页</span
                >
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page.sync="searchRowObj.pageNum"
                  :page-size="searchRowObj.pageSize"
                  layout="prev, pager, next, jumper"
                  :total="totalCount2"
                ></el-pagination>
              </div>
            </div>
            <!-- //---------------- -->
          </template>
        </el-table-column>
        <el-table-column label="名称 " prop="formName"> </el-table-column>
        <el-table-column label="文件">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :href="scope.row.templateFileUrl"
              :underline="false"
              target="_blank"
              >查看</el-link
            >
            <!-- {{ rowDataList }} -->
            <!-- {{ scope.row }} -->
            <!-- <el-tooltip placement="top" popper-class="atooltip">
              <div slot="content">
                <img :src="scope.row.templateFileUrl" alt="" />
              </div>
              <div class="img">
                <img :src="scope.row.templateFileUrl" alt="" />
              </div>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              popper-class="popper-class"
              content="添加子选项"
              placement="bottom-end"
            >
              <!-- v-if="scope.row.username != 'admin'" -->
              <el-button
                icon="el-icon-plus"
                circle
                size="20"
                type="success"
                @click="childAddClick(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              popper-class="popper-class"
              content="编辑"
              placement="bottom-end"
            >
              <!-- v-if="scope.row.username != 'admin'" -->
              <el-button
                icon="el-icon-edit-outline"
                circle
                size="20"
                type="success"
                @click="handelClickEdit(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              popper-class="popper-class"
              content="删除"
              placement="bottom-end"
            >
              <el-button
                icon="el-icon-delete"
                circle
                type="success"
                @click="handleDelete(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap" v-if="totalCount > 0">
        <div>
          <span>共</span>
          <span>{{ totalCount }}</span>
          <span>条,</span>
          <span
            >每页显示
            <el-select
              v-model="searchObj.pageSize"
              placeholder="请选择"
              @change="pageSizeChange"
              size="small"
            >
              <el-option
                v-for="item in pageNumberList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
            >条</span
          >
        </div>
        <div class="pagination-left" v-if="totalCount > searchObj.pageSize">
          <span>共{{ Math.ceil(totalCount / searchObj.pageSize) }}页</span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="searchObj.pageNum"
            :page-size="searchObj.pageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <electronicAdd
      ref="electronicAdd"
      @upData="getTableData"
      :formObj="formObj"
      :title="title"
    ></electronicAdd>
    <upDataFormPackaging
      ref="upDataFormPackaging"
      :editFormDefaulteArr="editFormDefaulteArr"
      @editUpData="editItemMsg"
      :title="title2"
    ></upDataFormPackaging>
  </div>
</template>


<script>
import {
  electronicFormQuery,
  electronicFormDelete,
  electronicFormItemQuery,
  electronicFormItemDelete,
  electronicFormGetAllLabels,
  electronicFormItemUpdate,
  electronicFormItemCreate,
  electronicFormItemDataSourceDelete,
} from '@/api/electronicForm';
import upDataFormPackaging from '@/components/upDataFormPackaging';
import electronicAdd from './components/electronicAdd';
import { clone } from '@/utils/utils';
const defaultSearchObj = {
  pageNum: 1,
  pageSize: 10,
  formName: '',
};
const defaultRowSearchObj = {
  pageNum: 1,
  pageSize: 10,
  formBid: '',
};
const defaultEditFormDefaulteArr = [
  {
    fieldName: 'itemName', //字段
    type: 'input', //类型
    name: '电子表单项名称', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: 'safasdfsadf', //默认值
  },
  {
    fieldName: 'labelList', //字段
    type: 'selectMultiple', //类型
    name: '电子表单项', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: [], //默认值
    selectList: [],
    selectValue: 'value', //名字
    selectId: 'label', //list中的需要发给后台的id
  },
];
export default {
  data() {
    return {
      pageNumberList: [
        { lable: 10, value: 10 },
        { lable: 20, value: 20 },
        { lable: 50, value: 50 },
        { lable: 100, value: 100 },
      ],
      editFormDefaulteArr: clone(defaultEditFormDefaulteArr),
      expandRowKeys: [],
      searchObj: clone(defaultSearchObj),
      searchRowObj: clone(defaultRowSearchObj),
      totalCount: '',
      totalCount2: '',
      postList: [],
      rowDataList: [],
      formObj: {},
      title: '新建电子表单',
      title2: '新建电子表单项',
      itemBid: '',
    };
  },
  mounted() {
    this.getTableData();
    this.getAllFormLabels();
  },
  methods: {
    pageSizeChange(eve) {
      this.searchObj.pageSize = eve;
      this.getTableData();
    },
    pageSizeChange2(eve) {
      this.searchRowObj.pageSize = eve;
      this.expandChange({ formBid: this.searchRowObj.formBid });
    },
    getTableData() {
      electronicFormQuery(this.searchObj).then((res) => {
        if (res.code == 200) {
          res.data.records.forEach((item) => {
            item.rowDataList = [];
            // item.expand = false;
          });
          this.postList = res.data.records;
          this.searchObj.pageNum = res.data.pageNum;
          this.searchObj.pageSize = res.data.pageSize;
          this.totalCount = res.data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.searchObj.pageNum = val;
      this.getTableData();
    },
    getAllFormLabels() {
      electronicFormGetAllLabels().then((res) => {
        if (res.code == 200) {
          this.editFormDefaulteArr[1].selectList = res.data;
        }
      });
    },
    resetSeach() {
      this.searchObj = clone(defaultSearchObj);
    },
    handelClickAdd() {
      this.title = '新建电子表单';

      this.formObj = {};
      this.$refs.electronicAdd.DialogShow = true;
    },
    handelClickEdit(row) {
      this.formObj = row;
      this.title = '编辑电子表单';
      this.$refs.electronicAdd.DialogShow = true;
    },
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该电子表单？',
        })
        .then(() => {
          electronicFormDelete(row.formBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            }
          });
        });
    },
    childAddClick(row) {
      this.expandRowKeys = [row.formBid];
      this.title2 = '新建电子表单项';
      this.editFormDefaulteArr.forEach((item) => {
        item.value = '';
        if (item.type == 'selectList') {
          item.value = [];
        }
      });
      this.itemBid = '';
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    expandChange(row) {
      console.log(row.formName);
      if (this.expandRowKeys.includes(row.formBid) && row.formName) {
        this.expandRowKeys = [];
      } else {
        this.expandRowKeys = [row.formBid];
        this.searchRowObj.formBid = row.formBid;
        electronicFormItemQuery(this.searchRowObj).then((res) => {
          if (res.code == 200) {
            this.postList.forEach((item, inx) => {
              if (item.formBid == row.formBid) {
                this.postList[inx].rowDataList = [];
                this.$set(this.postList[inx], 'rowDataList', res.data.records);
              }
            });

            this.searchRowObj.pageNum = res.data.pageNum;
            this.searchRowObj.pageSize = res.data.pageSize;
            this.totalCount2 = res.data.total;
          }
        });
      }
    },
    handelRowClickEdit(row) {
      console.log(row);
      this.title2 = '编辑电子表单项';
      this.itemBid = row.itemBid;
      this.editFormDefaulteArr[0].value = row.itemName;
      row.dsList.forEach((item) => {
        this.editFormDefaulteArr[1].value.push(item.label);
      });
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    handleRowDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          tips: '',
          content: '确定删除该电子表单项？',
        })
        .then(() => {
          electronicFormItemDelete(row.itemBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.expandChange({ formBid: this.searchRowObj.formBid });
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editItemMsg(data) {
      if (!this.itemBid) {
        //新建
        data.formBid = this.searchRowObj.formBid;
        electronicFormItemCreate(data).then((res) => {
          console.log(res);
          if (res.code == '200') {
            this.$refs.upDataFormPackaging.closeDialog();
            this.$msg.success('新建成功！');
            this.expandChange({ formBid: this.searchRowObj.formBid });
          }
          this.$refs.upDataFormPackaging.upDataMsg = '保存';
        });
      } else {
        console.log(this.searchRowObj.formBid);
        //编辑
        data.formBid = this.searchRowObj.formBid;
        data.itemBid = this.itemBid;
        electronicFormItemUpdate(data).then((res) => {
          if (res.code == '200') {
            this.$refs.upDataFormPackaging.closeDialog();
            this.$msg.success('修改成功！');
            this.expandChange({ formBid: this.searchRowObj.formBid });
          }
          this.$refs.upDataFormPackaging.upDataMsg = '保存';
        });
      }
    },
    handleClose(rowList, tag) {
      if (rowList.length < 2) {
        this.$msg.error('至少保留一个！');
        return;
      }
      electronicFormItemDataSourceDelete(tag.dsBid).then((res) => {
        if (res.code == 200) {
          rowList.splice(rowList.indexOf(tag), 1);
          this.$msg.success('操作成功！');
        }
      });
      // rowList.splice(rowList.indexOf(tag), 1);
    },
  },
  components: {
    electronicAdd,
    upDataFormPackaging,
  },
};
</script>

<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.small-table {
  width: 98%;
  margin-left: 1%;
}
.el-tag {
  margin-right: 5px;
}
</style>